/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */

export default function Contact() {
  return (
    <>
      {/*Hero Banner Section*/}
      <section className="hero_banner_img padding_top_60 padding_bottom_60 pb-0">
        <div className="banner_content">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 padding_top_100 margin_box sub_page_banner_content_box order02 mobile_text_center">
                <h1 className="font_size_48 line_height_60 color_222 margin_bottom_20">
                  Hãy liên hệ với chúng tôi
                </h1>
                <p className="font_size_18 line_height_30 color_5a5f69 margin_bottom_20 inner_sub_page_banner_content_box">
                  Thời gian là tiền bạc! Chúng tôi xem trọng khách hàng và thời
                  gian của mọi người, vì vậy, đội ngũ của chúng tôi luôn làm tốt
                  nhất có thể để giúp bạn giải quyết vấn đề nhanh chóng!
                </p>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 sub_page_banner_img order01">
                <figure>
                  <img
                    src="assets/images/sub_banner_img06.svg"
                    alt=""
                    className="img-fluid"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*End Slider Section*/}
      {/*Help Section*/}
      <section className="padding_bottom_60 padding_top_60 text-center">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-5 help_section_img">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.8502148675875!2d105.81723097600502!3d20.998640488810995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ac8f87256bbd%3A0xe7fb4ff48e908860!2zMzAgTmcuMTAyIFAuIFTDtCBWxKluaCBEaeG7h24sIEtoxrDGoW5nIFRydW5nLCBUaGFuaCBYdcOibiwgSMOgIE7hu5lpLCBWaWV0bmFt!5e0!3m2!1sen!2s!4v1698827135912!5m2!1sen!2s"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: 10 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="col" />
            <div className="col-xl-6 col-lg-6 col-md-6 text-left mobile_text_center">
              <h2 className="margin_bottom_20 font_size_36 line_height_48 color_222 ">
                Thông Tin Liên Hệ
              </h2>
              <p>Địa chỉ</p>
              <p className="pp location pr-0">
                Ngõ 102 Tô Vĩnh Diện, phường Khương Trung, quận Thanh Xuân, Hà
                Nội
              </p>
              <p>Điện thoại</p>
              <a href="tel:+(84)919931503">
                <p className="pp">+(84) 919.931.503</p>
              </a>
              <p>Email</p>
              <a
                href="mailto:admin@myvps.vn"
                className="text-decoration-none"
              >
                <p className="pp">admin@myvps.vn</p>
              </a>
              <p className="callnow">Telegram</p>
              <a href="https://t.me/myvpsvn">@myvpsvn</a>
              <p className="callnow">Fanpage</p>
              <a href="https://www.facebook.com/myvps.vn">https://www.facebook.com/myvps.vn</a>
              <p className="callnow">Tiktok</p>
              <a href="https://www.tiktok.com/@myvpsvn">https://www.tiktok.com/@myvpsvn</a>
              <p className="callnow">Instagram</p>
              <a href="https://www.instagram.com/myvpsvn/">https://www.instagram.com/myvpsvn/</a>
            </div>
          </div>
        </div>
      </section>
      {/*Ends Here*/}
    </>
  );
}